module.exports = __webpack_public_path__ + "media/images/front/knowledge_note/knowledge_note_logo-d9c9bdba765b60cc5f008255bad42b0f.png";